import { fetcher } from "@/lib/fetcher";
import { ApiResponse } from "./model";

// Minimal workspace information - matches backend WorkspaceInfo
export interface Workspace {
  workspace_id: string;
  organization_id: string;
  name: string;
  status: string;
}

export async function fetchUserWorkspaces(): Promise<Workspace[]> {
  const response = await fetcher<ApiResponse<Workspace>>(
    "/api/platform/chat-auth/v1/auth/workspaces"
  );

  return response.data ?? [];
}

